var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input-group" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.model,
          expression: "model"
        }
      ],
      staticClass: "checkbox option-input",
      attrs: { id: _vm.id, disabled: _vm.disabled, type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.model)
          ? _vm._i(_vm.model, null) > -1
          : _vm.model
      },
      on: {
        change: function($event) {
          var $$a = _vm.model,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.model = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.model = $$c
          }
        }
      }
    }),
    _c("label", { staticClass: "d-flex m-0", attrs: { for: _vm.id } }, [
      _c(
        "span",
        {
          staticClass: "mt-1 bg-white pr-3",
          class: { "bg-secondary-10 border-color--primary-5": _vm.hasError }
        },
        [_vm.model ? _c("em", { staticClass: "ic-check" }) : _vm._e()]
      ),
      _c("div", [
        _vm.headline
          ? _c(
              "label",
              {
                staticClass: "color-black font-weight-bold mb-n1",
                attrs: { for: _vm.id }
              },
              [_vm._v(" " + _vm._s(_vm.headline) + " ")]
            )
          : _vm._e(),
        _vm._v(" " + _vm._s(_vm.text) + " ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }